import React, { Fragment, useState, useEffect, useRef } from "react";
import { Form, ListGroup } from "react-bootstrap";
import { FormControl, Dropdown, InputGroup } from "react-bootstrap";
//  DATA
import Dept from "../../data/Dept";
import Doctors from "../../data/Doctors/all-doctors.json";

import { doctorDeptListBangalore } from "../../components/Doctors/departments/deptList";
import { doctorDeptListMysore } from "../../components/Doctors/departments/deptListMysore";
import { doctorDeptListRamanagar } from "../../components/Doctors/departments/ramanagarDeptList";
import { doctorDeptListNagaraBhavi } from "../../components/Doctors/departments/deptListNagarabhavi";
import { doctorDeptListTumakuru } from "../../components/Doctors/departments/deptListTumakuru";
const branchLinksWithDepts = {
  bangalore: doctorDeptListBangalore,
  mysore: doctorDeptListMysore,
  ramanagara: doctorDeptListRamanagar,
  tumakuru: doctorDeptListTumakuru,
  "kangaroocare-nagarabhavi-clinic": doctorDeptListNagaraBhavi,
};
const cityList = [
  {
    id: 1,
    city: "bangalore",
    cityName: "Bangalore",
    cityLink: "kcblr",
  },
  {
    id: 2,
    city: "mysore",
    cityName: "Mysore",
    cityLink: "kcmys",
  },
  {
    id: 3,
    city: "ramanagara",
    cityName: "Ramanagara",
    cityLink: "kcramanagar",
  },
  {
    id: 4,
    city: "kangaroocare-nagarabhavi-clinic",
    cityName: "Kangaroocare Nagarabhavi Clinic",
    cityLink: "kcclinicsnagarabhavi",
  },
  {
    id: 5,
    city: "tumakuru",
    cityName: "Tumakuru",
    cityLink: "tumakuru",
  },
];
const FindDoctorDetails = () => {
  const [selectCity, setSelectCity] = useState("");
  const [specialityList, setSpecialityList] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState("");

  const [doctors, setDoctors] = useState([]);
  // const [selectedDoctors, setSelectedDoctors] = useState("");

  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    setSelectedSpeciality("");
    setSpecialityList([]);
    setDoctors("");
    if (selectCity) {
      let branchData = branchLinksWithDepts[selectCity];

      console.log("branchData=>", branchData);

      setSpecialityList(branchData);
    }
  }, [selectCity]);

  useEffect(() => {
    if (selectCity && selectedSpeciality) {
      const getCityLink = cityList.find((city) => city.city === selectCity);

      console.log("getCityLink=>", getCityLink);

      console.log("Doctors=>", Doctors);

      let filterDoctors = Doctors.filter(
        (item) =>
          (item.dept === selectedSpeciality ||
            item?.deptList?.includes(selectedSpeciality)) &&
          (item.hospitals === getCityLink.cityLink ||
            item.hospitalArr?.includes(getCityLink.cityLink))
      );

      console.log("filterDoctors=>", filterDoctors);

      setDoctors(filterDoctors);
    }
  }, [selectCity, selectedSpeciality]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    const filteredOptions = doctors.filter((opt) =>
      opt.firstname.toLowerCase().includes(value.toLowerCase())
    );
    setFiltered(filteredOptions);
    setShowDropdown(true);
  };

  const handleFocus = () => {
    setFiltered(doctors);
    setShowDropdown(true);
  };

  const handleSelect = (value) => {
    let name = value.firstname;
    if (value.lastname && value.lastname !== ".") {
      name = name + " " + value.lastname;
    }
    const docUrl = `/doctor/${name.split(" ").join("-").toLocaleLowerCase()}/${
      value.id
    }`;

    window.location.replace(docUrl);

    // let { value } = event.target;
    // if (value) {
    //   let url = `/doctor/${value.firstname}-${value.lastname}/${value.id}`;
    //   window.location.replace(url);
    // }

    setShowDropdown(false);
  };

  const handleBlur = (e) => {
    // Close dropdown only if focus leaves the container
    if (!containerRef.current.contains(e.relatedTarget)) {
      setShowDropdown(false);
    }
  };
  return (
    <Fragment>
      <div className="findDoctorDiv pinkBackground">
        <div className="container">
          <div className="row mtn-30">
            <h2 className="col-12 findDocText">Find Doctors</h2>

            <div className="col-12">
              <div className="row">
                <div className="col-lg-4">
                  <Form.Control
                    as="select"
                    className="my-1 mr-sm-2 chooseSpecialitySelect"
                    custom
                    value={selectCity}
                    onChange={(e) => setSelectCity(e.target.value)}
                  >
                    <option value="0" hidden>
                      Choose Location
                    </option>
                    {cityList?.map(({ id, city, cityName }) => (
                      <option className="selectOption" key={id} value={city}>
                        {cityName}
                      </option>
                    ))}
                  </Form.Control>
                </div>
                <div className="col-lg-4">
                  <Form.Control
                    as="select"
                    className="my-1 mr-sm-2 chooseSpecialitySelect"
                    custom
                    value={selectedSpeciality}
                    onChange={(e) => setSelectedSpeciality(e.target.value)}
                  >
                    <option value="0" hidden>
                      Choose Speciality
                    </option>

                    {specialityList?.map(({ id, deptTitle, dept }) => (
                      <option className="selectOption" key={id} value={dept}>
                        {deptTitle}
                      </option>
                    ))}
                  </Form.Control>
                </div>
                <div className="col-lg-4">
                  <div
                    ref={containerRef}
                    style={{ position: "relative", width: "100%" }}
                  >
                    <FormControl
                      placeholder="Search..."
                      value={search}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      style={{ height: "55px" }}
                    />
                    {showDropdown && (
                      <ListGroup
                        style={{
                          position: "absolute",
                          width: "100%",
                          zIndex: 1,
                          backgroundColor: "white",
                          maxHeight: "200px",
                          overflowY: "auto",
                          border: "1px solid #ced4da",
                          borderTop: "none",
                          borderRadius: "0 0 4px 4px",
                        }}
                      >
                        {filtered.length > 0 ? (
                          filtered.map((item, idx) => (
                            <ListGroup.Item
                              key={idx}
                              action
                              tabIndex={0}
                              onTouchEnd={() => handleSelect(item)}
                              onClick={() => handleSelect(item)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") handleSelect(item);
                              }}
                            >
                              {item.firstname}&nbsp;
                              {item.lastname}
                            </ListGroup.Item>
                          ))
                        ) : (
                          <ListGroup.Item disabled>
                            No results found
                          </ListGroup.Item>
                        )}
                      </ListGroup>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FindDoctorDetails;
